import ltnNa from './siteDesignations/ltn-na';
import cvcLoads from './siteDesignations/central-valley';
import stockloadsAu from './siteDesignations/stockloads-australia';

import { NorthAmericanStates } from './siteDesignations/north-american-states';
import { Territories as AustralianTerritories } from './siteDesignations/australian-territories';

ltnNa.plugins.loadboard.states = NorthAmericanStates;
cvcLoads.plugins.loadboard.states = NorthAmericanStates;
stockloadsAu.plugins.loadboard.states = AustralianTerritories;

const designations = {};
designations[ltnNa.designationCode] = ltnNa;
designations[cvcLoads.designationCode] = cvcLoads;
designations[stockloadsAu.designationCode] = stockloadsAu;

const code = process.env.LTN_SITE_DESIGNATION;

const designation = designations[code] || ltnNa;
const response = { data: designation };

// make this thing look like an API call using a promise
const loadSiteDesignation = () => response;

// const siteDesignation = () => new Promise((resolve, reject) => {
//   resolve({ data: designation });
// });

export default {
  loadSiteDesignation,
};



// WEBPACK FOOTER //
// ./src/api/siteDesignation.js